import { Injectable } from '@angular/core';
import { SECONDS_PER_YEAR } from '@constants/app.constants';
import { CookieStorageService } from '@services/cookie-storage/cookie-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  readonly consentCookie = 'N0_CONSENT';

  constructor(private cookieStorage: CookieStorageService) {}

  shouldShowModal(): boolean {
    return !this.cookieStorage.getItem(this.consentCookie);
  }

  getConsentCookie(): string {
    return this.cookieStorage.getItem(this.consentCookie) ?? '';
  }

  createConsentCookie(value: string[]): void {
    this.cookieStorage.setItem(this.consentCookie, value.toString(), SECONDS_PER_YEAR);
  }
}
